// import { useRouter } from "../hooks/useRouter";
import { useEffect, useState } from "react";
import { createServiceBill, sendPaypalSuccessMail } from "src/service/pay";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { ICreateServiceBillReq } from "src/service/types/pay.type";
import { PayPalButton } from "react-paypal-button-v2";
import { insertPaypalModule } from "src/utils/pay/insertPaypalModule";
const ExceptPayPal = () => {
  const [userInfo] = useRecoilState(userInfoAtom);
  const [isShow, setIsShow] = useState<boolean>(false);
  // 결제 카드 교체 정보
  const payApply = async ({
    orderID,
    subscriptionID,
  }: {
    orderID: string;
    subscriptionID: string;
  }) => {
    // if (isCheckPay) {
    try {
      const serviceRequest: ICreateServiceBillReq = {
        // // billType: "PROMOTION",
        // billType: "PAY",
        // currency: "USD",
        // licenseCount: 1,
        // orderID: orderID,
        // payCompany: "PAYPAL",
        // payTerm: "month",
        // serviceBillUid: "",
        // subscriptionID: subscriptionID,
        // userCode: userInfo.userCode,
        // serviceBillUid: serviceBillUid,
        userCode: userInfo.userCode,
        billType: "PAY",
        billCode: "85eb96e6-5a1c-45ae-9e3e-6fa3963ce223", // price의 uid값 전달
        licenseCount: 10,
        orderID,
        subscriptionID,
        payTerm: "month",
        // startTime,
        // oldSubscriptionID,
        // currency: language === "en" ? "USD" : "WON", // 원화정보 세팅 검토 필요!
        currency: "USD",
        payCompany: "PAYPAL",
        // referralId,
        nxacAppUids: [],
      };

      const result = await createServiceBill({ ...serviceRequest });

      if (result) {
        alert("결제완료");
      }
    } catch (error: any) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage);
      }
    }
    // this.commonStore.setLoading(false);
    // }
  };
  useEffect(() => {
    insertPaypalModule().then(() => {
      setIsShow(true);
    });
    // async function init() {
    //   const inicisData = await getInicisData({ price: 2727273 });
    //   // const inicisData = await getInicisData({ price: 10 });
    //   setInicisData(inicisData);
    // }
    // init();
  }, []);

  const paypalSubscription = (data: any, actions: any) => {
    return actions.subscription.create({
      quantity: 1,
      plan_id: `P-2Y186011JG543310UM224M4A`,
      // plan_id: `P-1KN691814J493644BL3VP4KA`,
      // plan_id: `P-6G321970150743210L6GR4BA`,
      // plan_id: "P-4CD28116DL485711CL6GR2OI",
    });
  };
  return (
    <div>
      {isShow && (
        <PayPalButton
          options={{ vault: true }}
          createSubscription={paypalSubscription}
          onApprove={(data: any, actions: any) => {
            // Capture the funds from the transaction
            return actions.subscription.get().then(function (details: any) {
              console.log("paypal 결제 성공", details);
              // Show a success message to your buyer
              payApply({
                orderID: data.orderID,
                subscriptionID: data.subscriptionID,
              });
              sendPaypalSuccessMail({
                subscriptionId: data.subscriptionID,
              });
            });
          }}
        />
      )}
    </div>
  );
};

export default ExceptPayPal;
